{
  "randevu_sonuc_tip": {
    "Baslik": "Afspraak Resultaat Types",
    "Ad": "Naam",
    "Kod": "Code",
    "Hedef 1": "1ste Gesprek Doel",
    "Hedef 2": "2de Gesprek Doel",
    "Dahil": "Inbegrepen",
    "Dahil Degil": "Niet Inbegrepen",
    "Durum": "Status",
    "Arama": "Zoeken",
    "Ara": "Zoeken",
    "Temizle": "Wissen",
    "Kapat": "Sluiten",
    "Yenile": "Vernieuwen",
    "Data Yenile": "Gegevens Vernieuwen",
    "Ekle": "Toevoegen",
    "Filtrele": "Filteren",
    "Duzenle": "Bewerken",
    "Sil": "Verwijderen",
    "Kaydet": "Opslaan",
    "Guncelle": "Bijwerken",
    "Vazgec": "Annuleren",
    "Hepsi": "Alle",
    "Aktif": "Actief",
    "Pasif": "Passief",
    "ARA": "Zoeken"
  }
}
